/**
 * @param retrySubmitAction
 * @param retryWebhookAction
 * @returns {{jobs: {"7": {layout: {lg: number}, retryLink: *}, "8": {layout: {lg: number}, retryLink: *}}, all_status: {"1": {}, "2": {}, "3": {}, "4": {}, "5": {}, "6": {layout: {lg: number}}}}}
 */
export const createStatDashboardConfig = (retrySubmitAction, retryWebhookAction) => ({
  all_status: {
    total_task: {},
    total_pass: {},
    total_pending: {},
    total_waiting: {},
    total_failed: {},
    total_pending_post_back_4hrs: {
      title: 'Pending postback (> 4 hours)',
      layout: {lg: 4}
    },
  },
  jobs: {
    total_submitted_12hrs: {
      title: 'Total Submitted (> 12 hours)',
      layout: {lg: 4},
      retryLink: retrySubmitAction,
    },
    total_webhook_failed_6hrs: {
      title: 'Total Webhook Failed (> 6 hours)',
      layout: {lg: 4},
      retryLink: retryWebhookAction,
    },
  }
})
